// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__D0HQ_","sectionsWrapper":"style_sectionsWrapper__2O_P8"};